import { Messages } from 'primereact/messages';
import React, { useEffect } from 'react';

const showReleaseMessage = false;

const ReleaseMessage: React.FC = () => {
  const isNaRegion = window.location.hostname.endsWith('.ca');
  const scheduledTime = isNaRegion ? '11AM CST on Thursday,' : '6PM WST on Thursday,';

  const playStoreAppLink = 'https://play.google.com/store/apps/details?id=com.inxsoftware.assessorcloud';
  const appleAppStoreAppLink = 'https://apps.apple.com/au/app/inx-assessor-cloud/id1528939943';
  const supportLink = 'https://quartexsoftware.com/contact/';

  const messages = React.useRef<any>();

  useEffect(() => {
    if (showReleaseMessage) {
      messages.current?.replace({
        severity: 'info',
        sticky: true,
        content: (
          <>
            <div className="p-message-detail">
              <p className="p-message-summary">
                A hotfix release (version 3.0.8.3) is scheduled for <strong>{scheduledTime}</strong> Jul 23, 2026.
              </p>
              <p className="p-message-summary">
                This release includes:
                <ul>
                  <li className="p-message-summary">
                    Important security enhancements
                  </li>
                  <li className="p-message-summary">
                    Technical improvements to ensure system stability and performance
                  </li>
                </ul>
              </p>
              <p className="p-message-summary">
                There may be a short period of downtime (up to 30minutes) and intermittent interruptions during the deployment window.
              </p>
              <p className="p-message-summary">
                The current version of the Assessor mobile app (v3.0.54) remains backward compatible and will continue to function, but we recommend upgrading to the latest version (v3.1.0) on or after Jul 23, 2026. The app is available for download from both the Android and iOS app stores. Please sync all mobile assessments before upgrading to ensure a smooth transition.
              </p>
              <p className="p-message-summary">
                Please contact your Quartex Account Manager or our{' '}
                <a
                  href={supportLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  support team
                </a>{' '}
                if you have any enquiries.
              </p>
            </div>
          </>
        ),
      });
    }
  }, [messages, scheduledTime]);

  return <Messages ref={messages} />;
};

export default ReleaseMessage;
